<template>
  <div class="myStaking">
    <div class="main">
      <div
        :class="['record-list']"
        v-if="records.length != 0 && !isLoading"
        v-show="!isShowDetail"
      >
        <div class="record-item" v-for="(item, index) in records" :key="index">
          <YuliCard
            :data="item"
            @onDetail="handleToDetail"
            @onCountDownEnd="handleCountDownEnd"
          />
        </div>
      </div>

      <div class="tips" v-show="!records.length && !isShowDetail && !isLoading">
        <img
          class="tips-icon"
          :src="require('@/assets/images/YuliApp/YuliStaking/icon_nodata.png')"
        />
        <div class="tips-desc">Sorry, you don't have any staking currently</div>
      </div>

      <div class="loading" v-if="isLoading"></div>

      <div
        class="detail-item"
        v-show="!isShowRedeem && !isShowRenewal"
        v-if="isShowDetail"
      >
        <YuliDetailCard
          :data="detail"
          :isRedeeming="isRedeeming"
          :isClaiming="isPasscardClaiming"
          :redeemingToken="redeemingToken"
          @onClose="handleDetailBack"
          @onRedeem="handleRedeem"
          @onRenewal="handleRenewal"
          @onCountDownEnd="handleCountDownEnd"
          @onConsumComfrim="handleToConsumComfirm"
          @onClaimPasscard="handlePasscardClaimClick"
        />
      </div>

      <div class="detail-item" v-if="isShowRedeem">
        <YuliClaimSuccess :data="redeemDetail" @onClose="handleClaimBack" />
      </div>

      <div class="detail-item" v-if="isShowRenewal">
        <StakingRenew
          :data="currentYuli"
          @onClose="handleStakingRenewClose"
          @onRenewSuccess="handleRenewSuccess"
        />
      </div>
    </div>

    <div v-if="isShowConsumComfirm">
      <div class="RedeemConsumComfirm">
        <div class="mask"></div>
        <div class="pages">
          <div class="container">
            <div class="icon-close" @click="handleClose"></div>
            <div class="content">
              <div class="header">
                <div class="header-title">Notice for Claiming Rewards</div>
                <div class="header-title-sub">
                  You need to supplement the ARG Token cost required to pay for
                  your staking rewards
                </div>
              </div>

              <div class="content-consum">
                <div class="content-consum-text-wrap">
                  <div class="content-consum-text">Consumption:</div>
                </div>

                <div class="cost">
                  <img
                    :src="
                      require('@/assets/images/YuliApp/storageActivity/icon_arg.png')
                    "
                  />
                </div>
                <div :class="['arg-text', !isCanPay && 'arg-text-error']">
                  {{ handleCurrencyFormat(argHave) }}
                </div>
                <div class="arg-text">
                  /{{ argNeed ? argNeed.toLocaleString("en") : argNeed }} ARG
                </div>
              </div>
            </div>

            <div class="control">
              <div class="control-tips" v-if="!isCanPay">
                Sorry, you don't have enough ARG to continue currently
              </div>
              <div class="btn-list">
                <div :class="['btn', 'btn-claim']" @click="handleClaim">
                  <div
                    class="btn-loading"
                    v-if="isRedeeming && !isPaying"
                  ></div>

                  <div class="btn-text">Refuse and claim Yuli</div>
                </div>
                <div
                  :class="['btn', 'btn-pay', !isCanPay && 'btn-error']"
                  @click="handlePay"
                >
                  <div class="btn-loading" v-if="isPaying"></div>
                  <div class="btn-text" v-else>Pay to continue</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <RedeemConsumComfirm
          data={counsumData}
          argNeed={argNeed}
          argHave={argHave}
          isRedeeming={isRedeeming}
          isPaying={isPaying}
          onClose={() => {
            setShowConsumComfirm(false);
          }}
          onClaim={handleRedeem}
          onPay={handlePay}
        /> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { onBeforeMount, onMounted, ref, getCurrentInstance } from "vue";
import appBridging from "@/utils/appBridging.js";
import store from "@/store";
import { getYOG2StakingRecord, getYuliList } from "@/api/staking.js";
import { TOAST_TYPE } from "@/components/Toast/index.vue";
import YuliCard from "./components/YuliCard";
import YuliClaimSuccess from "./components/YuliClaimSuccess";
import YuliDetailCard from "./components/YuliDetailCard";
import StakingRenew from "./components/StakingRenew";
import { checkIsGen2 } from "@/utils/yuli.js";
import {
  getWallet,
  getUserProps,
  postYOG2StakingRecord,
  postYOG2StakingRedeem,
} from "@/api/staking.js";
import {
  YULI_ROLE_TYPE_MAP,
  YULI_ROLE_PROPERTY_TYPE_MAP,
  TIME_TYPE,
  TIME_TYPE_GROUP,
} from "@/components/YuliStaking/constants/type.js";
import {
  PASSCARD_INCOME_MAP,
  ART_INCOME_MAP,
  YULI_QUALITY_TYPE_MAP,
  getPasscardIncomByDay,
  ARG_COST_MAP,
} from "@/components/YuliStaking/constants/incomeMap.js";

export const STACKING_CONTENT_KEY = "staking_content";

export default {
  components: {
    YuliCard,
    YuliDetailCard,
    YuliClaimSuccess,
    StakingRenew,
  },
  computed: {
    ...mapState({
      init: (state) => state.global.init,
      statusBarHeight: (state) => state.global.statusBarHeight,
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  watch: {
    languageEnv: {
      async handler(value) {
        if (value) {
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        if (value) {
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    },
    isShowDetail: {
      handler(value) {
        // todo
        const record_el = document.querySelector(`#${STACKING_CONTENT_KEY}`);
        const _top = value ? 0 : this.scrollTopRef;
        record_el && (record_el.scrollTop = _top);
      },
      immediate: true,
      deep: true,
    },
    isShowRedeem: {
      handler(value) {
        value && this.handleToTop();
      },
      immediate: true,
      deep: true,
    },
    isShowConsumComfirm: {
      handler(value) {
        value && this.handleToTop();
      },
      immediate: true,
      deep: true,
    },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();

    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref("en");

    const records = ref([]);

    // 详情
    const detail = ref(null);
    const isShowDetail = ref(false);

    // 赎回
    const isRedeeming = ref(false);
    const redeemingToken = ref(0);
    const redeemDetail = ref(null);
    const isShowRedeem = ref(false);

    //  赎回确认
    const isShowConsumComfirm = ref(false);
    const counsumData = ref(null);
    const argHave = ref(0);
    const argNeed = ref(0);

    // 付款
    const isPay = ref(false);

    // passcard领取
    const isPasscardClaiming = ref(false);

    // 续订
    const isShowRenewal = ref(false);

    const scrollTopRef = ref(0);

    const isLoading = ref(true);

    const isPaying = ref(false);

    const currentYuli = ref(null);

    // const item = ref(null);

    onMounted(() => {
      handleInitStakingRecord(true);
    });

    /**
     * 处理加载列表
     */
    const handleInitStakingRecord = async (isNeedDetail = true) => {
      isLoading.value = true;

      const _list = await handleGetStakingRecordByServe(isNeedDetail);

      const _record = isNeedDetail ? _list : [];
      records.value = _record;

      // 红点通知
      handleRefreshDot(_list);

      isLoading.value = false;
    };

    /**
     * 获取质押记录
     */
    const handleGetStakingRecordByServe = async (isNeedDetail = true) => {
      /* eslint-disable */
      return new Promise(async (resolve) => {
        try {
          // 服务获取质押记录
          const res = await getYOG2StakingRecord({});
          const _list = res?.data || [];

          if (!isNeedDetail) {
            resolve(_list);
            return;
          }

          // 获取yuli的详情
          const yuli_res = await getYuliList();
          const yuli_list = yuli_res?.data || [];
          const detail_list = yuli_list.filter((_item) => {
            const token_id = Number(_item?.token_id || "");
            const is_free_role = _item?.is_free_role;
            const is_on_staking = _item?.extension?.is_on_staking;
            return checkIsGen2(token_id) && !is_free_role;
          });

          // 聚合两部分数据
          const list = [];
          for (let i in _list) {
            const _item = _list[i];
            const token_id = _item?.token_id;
            const _data = detail_list.find((item) => {
              const data_token = item?.token_id;
              return data_token === token_id;
            });
            const _new = { ..._data };
            const _extension_attribute = _data?.extension;
            _new.extension_attribute = _extension_attribute;
            _new.extension = { ..._item };
            // end_time: '1722182400'
            list.push(_new);
          }

          // 排序
          const _sort_list = [...list];
          _sort_list.sort((a, b) => {
            return a?.extension?.end_time - b?.extension?.end_time;
          });

          const _list_sort = _sort_list
            .map((item) => {
              // 之前是已赎回的最后，待赎回的最前，倒计时的在中间, passcard第二
              // 代赎回
              const isRedeem = getItemIsCanRedeem(item);
              // 已赎回
              const isOver = getItemIsOver(item);
              // 未领取passcard
              const isNotClaimPasscard = getPasscardIsCliam(item);
              // 定义积分
              let dex = 0;
              if (isRedeem) dex += 10;
              if (isOver) dex -= 5;
              if (isNotClaimPasscard) dex += 7;
              return {
                ...item,
                dex,
              };
            })
            .sort((a, b) => {
              // 按积分排序
              return b?.dex - a?.dex;
            });

          resolve(_list_sort);
        } catch (error) {
          resolve([]);
        }
      });
    };

    /**
     * 判断是否可以领取
     * @param item
     * @returns
     */
    const getItemIsCanRedeem = (item) => {
      const extension = item?.extension;
      const end_time = item?.end_time || extension?.end_time || 0;
      const nowaday = new Date().getTime();
      const isStakingOver = nowaday > end_time * 1000;

      const redeem_at = item?.redeem_at || extension?.redeem_at || "";
      const redeem_tx_hash =
        item?.redeem_tx_hash || extension?.redeem_tx_hash || "";
      const is_redeem = item?.is_redeem || false;
      const isRedeem = redeem_at || is_redeem;

      return isStakingOver && !isRedeem;
    };

    /**
     * 判断是否结束
     * @param item
     * @returns
     */
    const getItemIsOver = (item) => {
      const extension = item?.extension;
      const end_time = item?.end_time || extension?.end_time || 0;
      const nowaday = new Date().getTime();
      const isStakingOver = nowaday > end_time * 1000;

      const redeem_at = item?.redeem_at || extension?.redeem_at || "";
      const redeem_tx_hash =
        item?.redeem_tx_hash || extension?.redeem_tx_hash || "";
      const is_redeem = item?.is_redeem || false;
      const isRedeem = redeem_at || is_redeem;

      return isStakingOver && isRedeem;
    };

    /**
     * 判断是否领取过passcard(到期的情况下)
     */
    const getPasscardIsCliam = (item) => {
      const extension = item?.extension;

      const end_time = item?.end_time || extension?.end_time || 0;
      const nowaday = new Date().getTime();
      const isStakingOver = nowaday > end_time * 1000;

      const isCanClaimPasscard =
        extension?.passcard > 0
          ? extension?.passcard_at == 0 && extension?.passcard_tx_hash == ""
          : false;

      return isCanClaimPasscard && isStakingOver;
    };

    /**
     * 判断是否可以领取passcard
     */
    const getItemPasscardIsCanCliam = (item) => {
      const extension = item?.extension;

      const redeem_tx_hash =
        item?.redeem_tx_hash || extension?.redeem_tx_hash || "";
      const redeem_at = item?.redeem_at || extension?.redeem_at || "";
      const is_redeem = item?.is_redeem || false;
      const isRedeem = redeem_at || is_redeem;

      const isCanClaimPasscard =
        extension?.passcard > 0
          ? extension?.passcard_at == 0 && extension?.passcard_tx_hash == ""
          : false;

      return isCanClaimPasscard && isRedeem;
    };

    /**
     * 处理红点通知
     * @param list
     */
    const handleRefreshDot = (list) => {
      if (!list.length) return;
      const isNeedRedeem = list?.some((item) => {
        return getItemIsCanRedeem(item);
      });
      // || getItemPasscardIsCanCliam(item)
      emit("onRedDot", isNeedRedeem);
    };

    /**
     * 处理跳转至详情页
     */
    const handleToDetail = (item) => {
      detail.value = item;

      // 记录当前滚动位置
      const record_el = document.querySelector(`#${STACKING_CONTENT_KEY}`);
      const scrollTop_el = record_el?.scrollTop || 0;
      const scrollTop =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        scrollTop_el;
      scrollTopRef.current = scrollTop;

      isShowDetail.value = true;
    };

    /**
     * 处理倒计时结束
     */
    const handleCountDownEnd = () => {
      handleRefreshDot(records.value);
    };

    /**
     * 处理消耗确认
     */
    const handleToConsumComfirm = async (item) => {
      // 获取当前拥有的ARG
      const arg = handleGetCurrency();
      // 所需要消耗的ARG
      const extension_attribute = data?.extension_attribute;
      const extension = item?.extension;
      const days = extension?.days || 0;
      const role_type = extension_attribute?.role_type;
      const role_type_name = YULI_ROLE_PROPERTY_TYPE_MAP[role_type] || "";
      const _arg = Number(extension?.arg || "0");
      const _arg_cost_map = ARG_COST_MAP[role_type_name] || {};
      const need_cost_arg = _arg || _arg_cost_map[days] || 0;
      argNeed.value = need_cost_arg;
      counsumData.value = item;
      // isShowConsumComfirm.value = true;
    };

    /**
     * 更新Record 和 当前detail
     */
    const updateDetailByServeWithId = async (id) => {
      const _list = await handleGetStakingRecordByServe();
      records.value = [..._list];
      const list = [..._list];
      const _index = list.findIndex((item) => {
        const extension = item?.extension;
        return extension?.id === id;
      });
      const _item = list[_index] || null;
      if (_item) {
        if (isShowDetail) {
          detail.value = { ...list[_index] };
        }
      }
    };

    /**
     * 处理付款并赎回
     * @param item
     */
    const handlePay = async (item) => {
      if (isPaying.value) return;

      const token_id = item?.token_id;
      const extension = item?.extension;
      const id = extension?.id;

      // 处理付款
      isPaying.value = true;
      const res = await handlePayByServer(id);
      if (!res) {
        isPaying.value = false;
        return;
      }

      // 付款成功后关闭弹窗并更新
      updateDetailByServeWithId(id);

      isPaying.value = false;
      isShowConsumComfirm.value = false;
      handleSuccessTips("Pay Success!");
    };

    /**
     * 服务端付款
     * @param id
     */
    const handlePayByServer = async (id) => {
      return new Promise(async (resolve) => {
        try {
          const res = await putStaking(id, {
            address: account,
          });
          resolve(true);
        } catch (error) {
          const code = error?.response?.data?.code;
          const msg = error?.response?.data?.msg || "";

          if (code === 403001 && msg === "duplicate") {
            resolve(true);
            return;
          }

          const _msg = msg
            ? `${msg}! Please try again later!`
            : `Pay failed, please try again later!`;
          handleError(_msg);
          resolve(false);
        }
      });
    };

    /**
     * 处理赎回
     * @param data
     * @returns
     */
    const handleRenewal = async (item) => {
      const extension_attribute = item?.extension_attribute;
      const role_type = extension_attribute?.role_type;
      const role_type_name = YULI_ROLE_PROPERTY_TYPE_MAP[role_type] || "";
      const role_property = extension_attribute?.role_property;
      const role_property_name = YULI_ROLE_TYPE_MAP[role_property] || "";
      const level = extension_attribute?.level;
      currentYuli.value = {
        ...item,
        record: item?.extension,
        extension: extension_attribute,
        role_type_name,
        role_property_name,
        passcardMap: PASSCARD_INCOME_MAP?.[role_type_name] || {},
        artMap: ART_INCOME_MAP?.[role_type_name] || {},
        level,
      };
      isShowRenewal.value = true;
    };

    const handleStakingRenewClose = () => {
      isShowRenewal.value = false;
    };

    const handleRenewSuccess = () => {
      isShowRenewal.value = false;
      isShowDetail.value = false;
      handleInitStakingRecord();
    };

    /**
     * 处理赎回
     * @param item
     * @returns
     */
    const handleRedeem = async (item) => {
      if (isRedeeming.value) return;

      const token_id = item?.token_id;

      const extension = item?.extension;
      const id = extension?.id;

      isRedeeming.value = true;
      redeemingToken.value = token_id;
      redeemDetail.value = item;

      // 调用合约
      const res = await handleRedeemConfirm(token_id, id);
      if (res) {
        handleSuccess();

        // 通知APP更新数据
        appBridging.handleRefreshNativeCache("V1GetUserRoles");

        if (isShowConsumComfirm.value) {
          isPaying.value = false;
          isShowConsumComfirm.value = false;
        }

        // 更新数据状态
        const list = await handleGetStakingRecordByServe();
        const _index = list.findIndex((item) => {
          const extension = item?.extension;
          return extension?.id === id;
        });
        const _item = list[_index] || null;
        if (_item) {
          list[_index] = { ..._item, is_redeem: true };
          records.value = [...list];
          isRedeeming.value = false;
          redeemingToken.value = 0;
          if (isShowDetail) {
            detail.value = { ...list[_index] };
          }
          handleRefreshDot([...list]);
        }
      }
    };

    /**
     * 处理调用合约赎回
     */
    const handleRedeemConfirm = async (token_id, record_id) => {
      return new Promise(async (resolve) => {
        try {
          const res = await postYOG2StakingRedeem(record_id, {});
          resolve(res);
        } catch (error) {
          handleError();
          resolve(null);
        }
      });
    };

    /**
     * 处理错误提示
     */
    const handleError = (value) => {
      isPaying.value = false;
      isRedeeming.value = false;
      redeemingToken.value = 0;

      proxy.$toast.show({
        msg: `${value || "Redeem failed, please try again later!"}`,
        type: TOAST_TYPE.ERROR,
      });
    };

    /**
     * 处理成功提示
     */
    const handleSuccessTips = (value) => {
      proxy.$toast.show({
        msg: `${value}`,
        type: TOAST_TYPE.SUCCESS,
      });
    };

    /**
     * 处理成功提示
     */
    const handleSuccess = () => {
      isShowRedeem.value = true;
    };

    /**
     * 处理详情返回
     */
    const handleDetailBack = () => {
      isShowDetail.value = false;
    };

    /**
     * 处理领取成功返回
     */
    const handleClaimBack = () => {
      isShowRedeem.value = false;
      handleToTop();
    };

    /**
     * 获取当前拥有的货币值
     */
    const handleGetCurrency = async () => {
      const respons = (await getWallet()) || {};
      const res = respons?.data || {};
      const arg = res?.arg || 0;
      const art = res?.art || 0;
      argHave.value = arg;

      argHave.value = arg;
      return arg;
    };

    /**
     * 切换到顶部
     * @param top
     */
    const handleToTop = (top = 0) => {
      const record_el = document.querySelector(`#${STACKING_CONTENT_KEY}`);
      const record_el_2 = document.querySelector(`#${STACKING_CONTENT_KEY}_2`);
      record_el && (record_el.scrollTop = top);
      record_el_2 && (record_el_2.scrollTop = top);
      window.screenTop = top;
    };

    /**
     * 处理重置
     */
    const handleReset = () => {
      records.value = [];
      isRedeeming.value = false;
      isPasscardClaiming.value = false;
      redeemingToken.value = 0;
      isShowRedeem.value = false;
      isShowDetail.value = false;
    };

    const handlePasscardClaimClick = (data) => {
      // 未付款
      if (!data?.isConsum) {
        setShowConsumComfirm(true);
        return;
      }
      const sig = data?.extension?.signature;
      // 未操作赎回或续订
      if (sig == "" || sig.length == 0) {
        handleError(
          "Please Redeem Yuli or Continue Staking before you claim Passcard rewards."
        );
        return;
      }

      emit("onToMintPasscard", data);
    };

    return {
      localesPackage,
      localesEnv,
      records,
      detail,
      isShowDetail,
      isRedeeming,
      redeemingToken,
      redeemDetail,
      isShowRedeem,
      isShowConsumComfirm,
      counsumData,
      argHave,
      argNeed,
      isPay,
      isPasscardClaiming,
      isShowRenewal,
      scrollTopRef,
      handleInitStakingRecord,
      handleGetStakingRecordByServe,
      getItemIsCanRedeem,
      getItemIsOver,
      getPasscardIsCliam,
      getItemPasscardIsCanCliam,
      handleRefreshDot,
      handleToDetail,
      handleCountDownEnd,
      handleToConsumComfirm,
      updateDetailByServeWithId,
      handlePay,
      handlePayByServer,
      handleRenewal,
      handleRedeem,
      handleRedeemConfirm,
      handleError,
      handleSuccessTips,
      handleSuccess,
      handleDetailBack,
      handleClaimBack,
      handleGetCurrency,
      handleToTop,
      handleReset,
      isLoading,
      handlePasscardClaimClick,
      isPaying,
      handleStakingRenewClose,
      currentYuli,
      handleRenewSuccess,
    };
  },
};
</script>

<style lang="less" scoped>
.myStaking {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;

  .main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    .record {
      &-list {
        width: 365px;
        max-width: 356px;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-content: flex-start;
        margin-top: 5px;
      }

      &-item {
        flex-grow: 0;
        width: 175px;
        height: 319px;
        margin-right: 5px;
        margin-bottom: 6px;
        box-sizing: border-box;

        &:nth-child(2n) {
          margin-right: 0px;
        }
      }
    }
  }

  .tips {
    width: 100%;
    padding: 92px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background: linear-gradient(180deg, #12416c 0%, #1e779f 100%);
    min-height: 540px;

    &-icon {
      width: 120px;
      height: 120px;
    }

    &-desc {
      width: 275px;
      margin-top: 43px;
      color: #aae1ff;
      font-family: "Inter";
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      text-align: center;
    }
  }

  .loading {
    width: 40px;
    height: 40px;
    background-image: url("~@/assets/images/YuliApp/common/loading/icon_loading.png");
    background-size: 100% 100%;
    background-position: center;
    animation: rotate 1s linear infinite;
    margin-top: 50px;

    @keyframes rotate {
      from {
        transform-origin: center center;
        transform: rotate(0deg);
      }
      to {
        transform-origin: center center;
        transform: rotate(360deg);
      }
    }
  }
}
</style>
